import Vue from 'vue';
import AjaxUtils from "../../util/ajax_utils";
import Store from "../../data/store";
import $ from "jquery";
import * as showdown from 'showdown';

/**
 * READ THIS FIRST!!
 * 
 * This component is currently designed to work with the production UI only, it looks for elements
 * on the scan configuration page to be able to offer advice as a prospect is setting up a scan
 *
 * This can be altered down the line to work as part of a wizard or with the new UI to have a better
 * way to get these values.
 * 
 */


const WHITELISTING_TEXT = `\
## Considerations when scanning.

It's strongly recommended to "*allow list*" your scans to get the best results.

AppCheck is a tool to help you and your organisation identify vulnerabilities, while there is a temptation to want to see things from the perspective of what and attacker see's ultimately this view is flawed.

Any scanner no matter how sophisticated is going to trigger IPS's, WAF's and Firewall's, an attacker always has the advantage of time and regardless of the defences in place, the best approach is to assume anything public is visible.

For this reason it's best not to hinder the scanner and to "*allow list*" AppChecks's IP ranges.

## AppCheck's IP Ranges

* 62.253.231.16/28
* 89.248.48.224/27
* 185.221.147.96/27
* 213.123.49.48/29
* 157.96.33.80/28

It's important to understand AppCheck does not require any additional port's opening, it just needs to be able to see what you already have open without being blocked.

For more information see the [support article](https://support.appcheck-ng.com/hc/en-us/articles/115002550565-AppCheck-s-IP-Range)
`;

const TARGET_RESOLUTION =`\
While setting up a scan we will test that your web applications can be resolved and will provide screenshots for varification. 
`;

export const ApckScanConfigSidebar = {
    components: {
    },
    props: {
        imgSrc: {
            default: '/pre-scan/image',
            type: String
        }
    },
    data: function() {
        return {
            WHITELISTING_TEXT: WHITELISTING_TEXT,
            TARGET_RESOLUTION: TARGET_RESOLUTION,
            form_element: null,
            targets: [],
            scanhub: null
        };
    },
    methods: {
        markdown: function(text) {
            let converter = new showdown.Converter();
            if (text) {
                return converter.makeHtml(text);
            }
        },
        attach_observer(query, observer) {
            let cmp = this;
            // Define what element to observe and what types of mutations
            let config = { attributes: true, attributeOldValue: true, attributeFilter: ['value'] };
            
            let element = $(query);

            if(element) {

                observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        console.log(mutation);
                        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                            // Set the value on the target object
                            element.trigger('change');
                        }
                    });
                });

                observer.observe(element[0], config);
            }
        }
    },
    mounted: function() {
        let cmp = this;

        let form = $("form[action='/scans/advanced']");
        cmp.form_element = form;

        let mapping = {
            'target_tags': {
                el: "input[name=\'target_tags\']",
                name: 'targets',
                use_json: true
            },
            'dev_settings.scanning_hub': {
                el: "select[name='dev_settings.scanning_hub']",
                name: 'scanhub',
                use_json: false
            }
        };

        let set_value = function(element, name){
            if(mapping[name] !== undefined) {
                let _map = mapping[name];

                let el = $(_map.el);

                let value = el.val();
                if (value) {
                    if (_map.use_json) {
                        try {
                            cmp[_map.name] = JSON.parse(value);
                        } catch(error) {
                            console.error(error);
                        }
                    } else {
                        cmp[_map.name] = value;
                    }
                }
            }
        };


        form.bind('change', (event) => {
            if (event.target){
                let element = event.target
                let name = element.name
                setTimeout(function(){
                    set_value(element, name);
                }, 10);
            }
        });

        set_value("input[name='target_tags']", 'target_tags');

        set_value("select[name='dev_settings.scanning_hub']", 'dev_settings.scanning_hub');

    },
    watch: {
        targets: function(newVal, oldVal){
            let targets = [];
            for (let _target in newVal) {
                if(_target.application) {
                    targets.push(target.name);
                }
            }

            $.post(this.imgSrc, {
                urls: targets.join(","),
                scanhub: this.scanhub
            });
        }
    },
    template: `
        <apck-panel no-border title="Scan Configuration Helper">
            
            <div class="apck-scan-config-sidebar">

                <apck-panel title="Allow Lists">
                    <div class="markdown" v-html="markdown(WHITELISTING_TEXT)" />
                </apck-panel>

                <apck-panel title="Application Resolution">

                    <div class="markdown" v-html="markdown(TARGET_RESOLUTION)" />

                    <div v-if="targets.length" v-for="target in targets">
                        <span>{{ target.name }} - {{ target.application }}</span>
                    </div>

                    <div v-else>
                        <span>No targets have been input</span>
                    </div>

                    <div v-if="scanhub">
                        <span>{{ scanhub }}</span>
                    </div>
                    
                </apck-panel>

                <apck-panel title="Consider Scope Size">
                    
                </apck-panel>

                <apck-panel title="Authentication">
                    
                </apck-panel>

            </div>

        </apck-panel>
    `
}